var audio_rtlignore_default = {
  "fontElementMap": "_0D4y9",
  "container": "ULhod",
  "customPlayer": "zhSMq",
  "slim": "y6Jf3",
  "playPauseButton": "jJrcp",
  "coverImage": "gEH25",
  "trackDetailsContainer": "_8A1iS",
  "controlsContainer": "rOaSX",
  "controlsGroup": "Uqluf",
  "sliderContainer": "J096x",
  "audioDuration": "mp6tX",
  "isLoading": "hqSX3",
  "audioIconButton": "P43YB",
  "audioVolumeWrapper": "UwXBh",
  "volumeSliderWrapper": "zlH2Q",
  "audioDetails": "JjJ5l",
  "authorName": "kmbAD",
  "title": "kEPV7",
  "audioContextMenuWrapper": "IYTbo",
  "dropdownMenuWrapper": "MaK1r",
  "dropdownSelectedButton": "mE9L0",
  "dropdownContent": "iF1wb",
  "dropdownContentWithIcon": "zYe43",
  "audioLoader": "WyfMG"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
